/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */

/*
This is relevent transactions page having transactions from operative and credit card accounts */
/*global showAjaxError:true*/
/* eslint-disable no-undef */
import {
    PolymerElement,
    html
} from '@polymer/polymer/polymer-element.js';
import {
    mixinBehaviors
} from '@polymer/polymer/lib/legacy/class.js';
import './app-network-error.js';
class RelevantTransaction extends mixinBehaviors([accessibilityBehaviours.commonFunctions], PolymerElement) {
    static get template() {
            return html `
    <style include="app-styles">
      .hide-amt{
        display: none
      }
      .dashboard-paper-card-relevant-recent[phone] {
        height: 260px;
    }
      
	  .supporting-msg-container {
        height: 100%;
      }
      supporting-msg {
        --supporting-msg-min-height: 100%;
        --supporting-msg-padding-top: 0px;
        --content-style : {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    </style>
    <oe-ajax id="fetchFrquentTransactions" method="get" handle-as="json" content-type="application/json" on-response="mapFrequentTransactions" on-error='_relevantTransactionError'></oe-ajax>
 
      <app-media-query phone={{phone}} desktop={{desktop}} tablet={{tablet}}></app-media-query>
 
      <div class="dashboard-paper-card-relevant-recent" phone$={{phone}}>
        <template is="dom-if" if="{{showNodataFetchMsg}}">
          <div>
            <app-network-error  icon-name="cloud-off" hiddenValue={{showNodataFetchMsg}}} background="light-background" description="l_try_after_sometime" title="l_could_not_fetch_data"></app-network-error>
          </div>
        </template>
        <template is="dom-if" if="{{relevantTransactionMsg}}">
          <div class="horizontal center-center layout supporting-msg-container">
              <supporting-msg  description="" icon-name="no_txn" background="light-background" title-msg="l_noRelevantTransactionsFound"></supporting-msg>
          </div>
        </template>
        <template is="dom-if" if="{{releventTransactionLoader}}">
          <div class="horizontal center-center layout full-height">
            <paper-spinner id="recent_transaction_spinner" active></paper-spinner>
          </div>
        </template>
     
        <template is="dom-if" if={{!relevantTransactionMsg}}>
            <template is="dom-repeat" items="{{data}}" id="frequentTransDom">
              <div class="outlineOffset margin-b-zero margin-t-zero mdl-cell mdl-grid mdl-grid--no-spacing mdl-cell--12-col" tabindex="0" on-keydown="_gotoTransactionDDARMA" on-tap="_gotoTransactionRMA">
                  <div class$="[[getTranactionClasses(item)]]">
                   <div>
                    <div class="primary-dark-text-m text-overflow-ellipsis font-medium full-width">
                      {{item.beneficiaryName}}
                    </div>
                    <div class$="[[getDescClasses(item)]]">
                      {{item.menuDescription}}
                    </div>
                    </div>
                  </div>
                  <div class="content-align-horizontal-end mdl-cell mdl-cell--2-col-phone mdl-cell--6-col-desktop mdl-grid">
                    <div class$="[[getAmtClasses(item)]]">
                      {{formatAmount(item.currency.cmCode, item.modeAmount)}}
                      </div>
                      <div class$="outlineOffset [[getActionClasses(item)]]" tabindex="0" on-keydown="_gotoTransactionDDA" on-tap="_gotoTransaction">
                        <oe-i18n-msg msgid="l_RepeatPayment" id="l_RepeatPayment_id"></oe-i18n-msg>
                      </div>
                  </div>
                  <div class="full-width mdl-grid" hidden$="[[checkIfLastItem(item)]]">
                      <div class="border-b-1px full-width"></div>
                  </div>
              </div>
            </template>
        </template>
      </div>
    `;
        }
        /**
         * Array of strings describing multi-property observer methods and their
         * dependant properties
         */
    static get properties() {
        return {
            /* releventTransactionLoader */
            showNodataFetchMsg: {
                type: Boolean,
                value: false,
                notify: true
            },
            releventTransactionLoader: {
                type: Boolean,
                value: true,
                notify: true
            },
            menuObject: {
                type: Object,
                notify: true
            },
            data: {
                type: Array,
                notify: true,
                observer: 'dataChanged'
            },
            //Message to be shown on dashboard if no relevant records are found
            relevantTransactionMsg: {
                type: Boolean,
                value: false
            },
            fromAcct: {
                type: Object,
                value: {}
            },
            toAcct: {
                type: Object,
                value: {}
            },
            addFundsAmount: Number
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.$.fetchFrquentTransactions.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/frequent-transactions';
        this.$.fetchFrquentTransactions.generateRequest();
        this.menuObject = {
            "MNU2": {
                "menuId": "ORBIL",
                "menuDescription": getLabel("l_BillPayment")
            },
            "MNU1": {
                "menuId": "ORACC",
                "menuDescription": getLabel("l_FundTransferOwnAccount")
            },
            "MNU3": {
                "menuId": "ORCNT",
                "menuDescription": getLabel("l_Fundtransfer")
            },
            "MNU5": {
                "menuId": "RMA",
                "menuDescription": getLabel("l_bookRmAppointment")
            }
        }
    }
    mapFrequentTransactions(e) {
        if (!_.isEmpty(e.detail.response)) {
            this.data = e.detail.response;

            for (var i = 0; i < this.data.length; i++) {
                var key = this.data[i].menu;
                this.data[i] = Object.assign(this.data[i], this.menuObject[key]);
            }
            this.set('data', this.data);
        } else {
            this.releventTransactionLoader = false;
            this.relevantTransactionMsg = true;
        }
    }
    _gotoTransaction(e) {
        if (e.model.item.menuId == 'ORACC') {
            var fetchAccountsAjax = document.createElement('oe-ajax');
            var self = this;
            fetchAccountsAjax.contentType = "application/json";
            fetchAccountsAjax.handleAs = "json";
            fetchAccountsAjax.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/operativeaccounts';
            fetchAccountsAjax.method = 'get';
            fetchAccountsAjax.addEventListener('response', function(event) {
                self.dispatchEvent(new CustomEvent('stop-processing-loader', {
                    bubbles: true,
                    composed: true
                }));
                if (event.detail.response.length > 0) {
                    var response = event.detail.response;
                    for (var i = 0; i < response.length; i++) {
                        if (e.model.item.toAccountId == response[i].accountId)
                            self.toAccountId = response[i]
                        else if (e.model.item.fromAccountId == response[i].accountId)
                            self.fromAccountId = response[i];
                    }
                }
                //changes done for feature 301793
                var displayBoxAccountFormatted = self.fromAccountId.accountNickName + " " + maskAccount.accountFormat(self.fromAccountId.accountId, self.fromAccountId.branchCode);
                var accountMasked = maskAccount.accountFormat(self.fromAccountId.accountId, self.fromAccountId.branchCode);

                self.fromAccountId['displayBoxAccountFormatted'] = displayBoxAccountFormatted;
                self.fromAccountId['accountMasked'] = accountMasked;

                var data = {
                    "selectedaccountpage": 4,
                    "selectedAccount": self.toAccountId,
                    "selectedFromAccount": self.fromAccountId,
                    "addFundsAmount": e.model.item.modeAmount
                };
                window.oe_navigate_to("/oprAccounts", data);
            });
            fetchAccountsAjax.addEventListener('error', function(event) {
                self.dispatchEvent(new CustomEvent('stop-processing-loader', {
                    bubbles: true,
                    composed: true
                }));
                showAjaxError(event);
            });
            oeAjaxEventListner(fetchAccountsAjax);
            fetchAccountsAjax.generateRequest();

        } else if (e.model.item.menuId == 'RMA') {
            var servListdata = {};
            servListdata = {
                srType: "RMA",
                navigateURL: "/service-requests-listing",
                successMsg: "l_rmAppointment",
                api: "api/CBUsers/<userId>/rm-appointment-requests",
                serviceRequestName: "l_bookRmAppointment"
            };
            window.oe_navigate_to("/retail-service-request-create", {
                data: servListdata
            });

        }
    }
    dataChanged(n) {
        if (!_.isEmpty(n)) {
            this.releventTransactionLoader = false;
        }
    }
    formatAmount(currencyCode, amount) {
        return currency.symbolize(currencyCode + " " + amount);
    }

    _gotoTransactionDDA(keyboardEvent) {
        if (keyboardEvent.code === "Enter") {
            this._gotoTransaction(keyboardEvent);
        }
    }
    _gotoTransactionDDARMA(keyboardEvent){
        if (keyboardEvent.code === "Enter" && keyboardEvent.model.item && keyboardEvent.model.item.menuId == 'RMA') {
            this._gotoTransaction(keyboardEvent);
        }
    }
    _gotoTransactionRMA(e){
        if ( e.model.item && e.model.item.menuId == 'RMA') {
            this._gotoTransaction(e);
        }
    }
    checkIfLastItem(item) {
        if (item.menuId == 'RMA') {
            return true;
        } else {
            return false;
        }
    }
    getTranactionClasses(item) {
      var classes = "mdl-cell mdl-cell--2-col-phone mdl-cell--6-col-desktop mdl-grid ";
      if (item.menuId == 'RMA') classes += ' full-width'; else classes += '';
      return classes;
    }
    getDescClasses(item) {
        var classes = "horizontal layout center ";
        if (item.menuId == 'RMA') classes += ' primary-dark-text-m font-medium text-brand-color cursor-pointer';
        else classes += ' secondary-dark-text-xs';
        return classes;
    }
    getAmtClasses(item) {
        var classes = "primary-dark-text-m text-overflow-ellipsis content-align-horizontal-end full-width";
        if (item.menuId == 'RMA') classes = 'hide-amt';
        return classes;
    }
    getActionClasses(item) {
        var classes = "font-size-m text-brand-color text-transform-uppercase cursor-pointer";
        if (item.menuId == 'RMA') classes = 'hide-amt';
        return classes;
    }
    _relevantTransactionError() {
        this.releventTransactionLoader = false;
        this.showNodataFetchMsg = true;
    }
}
window.customElements.define('relevant-transaction', RelevantTransaction);
